import { Box, Stack, Typography } from "@mui/joy";
import { theme } from "styles/theme";

export default function CompareWithCounseling395({
  type,
}: {
  type: "quantity" | "cost";
}) {
  const data = {
    quantity: [
      { title: "심리상담", amount: "200분", width: "16%" },
      {
        title: "디스턴싱",
        amount: "600분",
        width: "100%",
        isHighlight: true,
        label: "6x",
      },
    ],
    cost: [
      { title: "심리상담", amount: "120만 원", width: "100%" },
      {
        title: "디스턴싱",
        amount: "39만 5천 원",
        width: "25%",
        isHighlight: true,
        label: "1/4x",
      },
    ],
  };
  return (
    <Stack sx={{ width: "100%" }} spacing={"12px"} alignItems="center">
      {data[type].map(({ title, amount, width, isHighlight, label }) => (
        <Stack spacing="8px" sx={{ width: "100%" }}>
          <Box
            sx={{
              width: width,
              height: "12px",
              borderRadius: "8px",
              ...(isHighlight
                ? { backgroundColor: theme.vars.palette.Content.Highlight }
                : { backgroundColor: theme.vars.palette.Content.Weak }),
            }}
          />
          <Stack
            direction="row"
            justifyContent={"space-between"}
            sx={{ width: "100%", height: "18px" }}
          >
            <Typography
              variant="Caption"
              fontWeight={700}
              sx={{
                color:
                  title === "디스턴싱"
                    ? theme.vars.palette.Content.Highlight
                    : theme.vars.palette.Content.Weak,
              }}
            >
              {title}
            </Typography>
            {label && (
              <Typography
                variant="H3"
                fontWeight={700}
                sx={{ color: theme.vars.palette.Content.Highlight }}
              >
                {label}
              </Typography>
            )}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}